import { StatoAttoEnum } from "../enum/stato-atto-enum";
import { TipoAttoEnum } from "../enum/tipo-atto-enum";
import { TipologiaDecretoEnum } from "../enum/tipologia-decreto-enum";
import { DatiContabiliDTO } from "./dati-contabiliDTO";
import { DocumentoDTO } from "./documentoDTO";
import { MetadatiRepertorioDTO } from "./metadati-repertorioDTO";
import { SettoreDTO } from "./settoreDTO";
import { UtenteDTO } from "./utenteDTO";
import { VisibilitaAttoDTO } from "./visibilita-attoDTO";

export class AttoDTO {
    id: string;
    nome: string;
    descrizione: string;
    oggetto: string;
    tipo: TipoAttoEnum;
    redattore: UtenteDTO;
    settore: SettoreDTO;
    tipologiaDecreto: TipologiaDecretoEnum;
    datiContabili: DatiContabiliDTO[];
    pubblicabile: boolean;
    riservato: boolean;
    responsabile: UtenteDTO;
    stato: StatoAttoEnum;
    primario: DocumentoDTO;
    contenutoAtto: string;
    allegati: DocumentoDTO[];
    visibilitaAtto: VisibilitaAttoDTO[];
    dataUltimaModifica: string;
    dataInserimento: string;
    dataConclusione: string;
    motivoStato: string;
    rimandato: Boolean;
    metadatiRepertorio: MetadatiRepertorioDTO;
    progressivo: number;
    relazioneVerificatore: DocumentoDTO;
    ordinario: boolean;
    inseritoAMano?: boolean; // usato solo per le note-liquidazione



}

